import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Grid, IconButton, MenuItem, TextField, Typography, Chip, Autocomplete, FormControl, Select } from '@mui/material';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Delete, Add } from '@mui/icons-material';
import { ItemServices } from './ItemServices';
import Loading from '../../../../components/Loader/Loading';
import Swal from 'sweetalert2';
import ServiceSelectionComponent from './ServiceSelectionComponent';
import SelectedServices from './SelectedServices';

const ServiceRelationManager = () => {
    const { control, setValue, formState: { errors },watch } = useFormContext();
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [childServices, setChildServices] = useState([]);
    const [servicesMap, setServicesMap] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingServices, setLoadingServices] = useState({});

    const serviceRelations = useWatch({ control, name: 'serviceRelations' }) || [];

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const response = await ItemServices.getCategories();
            if (response.success == '1') {
                setCategories(response.data || []);
            }
        } catch (error) {
            console.error("Failed to fetch categories:", error);
        } finally {
            setLoading(false);
        }
    };

    const categoryId = watch('serviceCategoryId');
    const subCategoryId = watch('subCategoryId');

    // fetch subcategory list by selected category id
     const fetchSubCategoryList= async()=>{
        console.log("fetching sub categories function executed:",categoryId);
        try {
            const subCategoryListResponse = await ItemServices.subCategoryList({categoryId:categoryId});
            // console.log("sub category list Response:",subCategoryListResponse);
            if(subCategoryListResponse.success=='1'){
                setSubCategories(subCategoryListResponse.data)
            }
        } catch (error) {
        
        }finally{
        // setIsSubmitted(false);
        }
    }
    useEffect(()=>{
        if(categoryId){
            console.log("fetching sub categories for category id:",categoryId);
            fetchSubCategoryList();
        }
    },[categoryId])
    //fetch master services list by selected subcategory id
    const fetchServiceList= async()=>{
        try {
        const serviceListResponse = await ItemServices.serviceList(subCategoryId);
        // console.log("service list Response:",serviceListResponse);
        if(serviceListResponse.success=='1'){
            setServiceList(serviceListResponse.data)
        }
        } catch (error) {
        
        }finally{
        // setIsSubmitted(false);
        }
    }
    useEffect(()=>{
        if(subCategoryId){
            fetchServiceList();
        }else{
            setServiceList([]);
        }
    },[subCategoryId])

    const handleAddRelation = () => {
        const newRelations = [
            ...serviceRelations,
            { serviceCategoryId: null, servicesMasterId: null }
        ];
        setValue('serviceRelations', newRelations, { shouldValidate: true });
    };

    const handleRemoveRelation = (index) => {
        const newRelations = serviceRelations.filter((_, i) => i !== index);
        setValue('serviceRelations', newRelations, { shouldValidate: true });
    };

    

   

    // useEffect(() => {
    //     serviceRelations.forEach((relation, index) => {
    //         if (relation.serviceCategoryId && !servicesMap[relation.serviceCategoryId]) {
    //             fetchServicesByCategory(relation.serviceCategoryId, index);
    //         }
    //     });
    // }, [serviceRelations]);

    if (loading) {
        return <Loading />;
    }
    
    return (
        <Card sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                    Service Relations
                </Typography>
                
            </Box>
            <Grid container spacing={1} sx={{p:'1% 2%'}}>
                <Grid item xs={12} sm={6} >
                    <Typography sx={{fontWeight:600,fontSize:'0.75rem'}}>Category </Typography>
                    <Controller
                        name='serviceCategoryId'
                        control={control}
                        // rules={{required:'select category'}}
                        render={({field,fieldState:{error}})=>(
                            <FormControl size='small' sx={{ minWidth: "100%" }}>
                                <Select
                                    {...field}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;                                
                                        field.onChange(selectedValue);
                                    }}
                                    sx={{
                                        fontSize: '0.75rem',
                                        '& .MuiSelect-select': {
                                        display: 'flex',
                                        alignItems: 'center',
                                        },
                                    }}
                                    error={!!error}
                                    // helperText={error && error?.message}
                                >
                                { categories &&
                                    categories.map((category,index)=>(
                                    <MenuItem sx={{fontSize:'0.75rem'}} value={category.id} key={index}>{category.title}</MenuItem>
                                    ))

                                }
                                </Select>
                            </FormControl>
                        )}  
                    />
                </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography sx={{fontWeight:600,fontSize:'0.75rem'}}>Sub Category </Typography>
                    <Controller
                        name='subCategoryId'
                        control={control}
                        // rules={{required:'select sub-category'}}
                        render={({field,fieldState:{error}})=>(
                            <FormControl size='small' sx={{ minWidth: "100%" }}>
                            {/* <InputLabel id="">Select Gender</InputLabel> */}
                                <Select
                                    {...field}
                                    disabled={ categoryId == '0' || !categoryId}
                                    // label="Select Gender"
                                    sx={{
                                        // minHeight: '0px',
                                        // height: '1.6rem',
                                        fontSize: '0.75rem',
                                        '& .MuiSelect-select': {
                                        // padding: '0 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        },
                                    }}
                                    error={!!error}
                                    // helperText={error && error?.message}
                                >
                                {subCategories &&
                                    subCategories.map((subCategory,scIndex)=>(
                                    <MenuItem sx={{fontSize:'0.75rem'}} value={subCategory.id} key={scIndex}>{subCategory.title}</MenuItem>
                                    ))
                                }
                                </Select>
                            </FormControl>
                        )}  
                    />
                </Grid>  
            <ServiceSelectionComponent serviceList={serviceList} categoryList={categories} subCategoryList={subCategories} />  
            </Grid>

            {serviceRelations.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                    <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                        No service relations added. Click "Add Relation" to start.
                    </Typography>
                </Box>
            ) : (
                <SelectedServices serviceList={serviceList}/>
            )}

            {/* <Typography sx={{ fontSize: '0.65rem', color: '#999', mt: 1 }}>
                * Service relations will be fully replaced on update. Each relation links items to specific service categories and optionally to specific services.
            </Typography> */}
        </Card>
    );
};

export default ServiceRelationManager;
